"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Types = require("./components/inputs/Types");
var _FacetFilterView = _interopRequireDefault(require("./FacetFilterView"));
var _excluded = ["section"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var FacetFilterController = function FacetFilterController(props) {
  /**
   * update checkbox state
   * 1. checkbox state
   * 2. subject state
   */
  var filterState = props.filterState,
    data = props.data,
    facetsConfig = props.facetsConfig,
    facetSectionConfig = props.facetSectionConfig;
  var updateFacetState = function updateFacetState(filterSections) {
    var updateSections = _toConsumableArray(filterSections);
    if (!_lodash.default.isEmpty(filterState)) {
      var _loop = function _loop() {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        updateSections.forEach(function (sideBar) {
          if (sideBar.type === _Types.InputTypes.CHECKBOX && sideBar.datafield === key) {
            sideBar.facetValues.forEach(function (item) {
              item.isChecked = value[item.name] ? value[item.name] : false;
            });
          }
          if (sideBar.type === _Types.InputTypes.SLIDER && sideBar.datafield === key) {
            sideBar.facetValues = value;
          }
        });
      };
      for (var _i = 0, _Object$entries = Object.entries(filterState); _i < _Object$entries.length; _i++) {
        _loop();
      }
    } else {
      updateSections.forEach(function (sideBar) {
        if (sideBar.type === _Types.InputTypes.CHECKBOX) {
          sideBar.facetValues.forEach(function (item) {
            item.isChecked = false;
          });
        }
        /**
         * set default value for slider - on clear all filter
         */
        if (sideBar.type === _Types.InputTypes.SLIDER) {
          var minLowerBound = sideBar.minLowerBound,
            maxUpperBound = sideBar.maxUpperBound;
          sideBar.facetValues = [minLowerBound, maxUpperBound];
        }
      });
    }
    return updateSections;
  };
  var arrangeBySections = function arrangeBySections(arr) {
    var sideBar = {};
    arr.forEach(function (_ref) {
      var section = _ref.section,
        item = _objectWithoutProperties(_ref, _excluded);
      var isExpanded = facetSectionConfig[section].isExpanded;
      if (!sideBar[section]) {
        sideBar[section] = {
          name: section,
          sectionName: section,
          expandSection: isExpanded !== undefined && typeof isExpanded === 'boolean' ? isExpanded : true,
          items: []
        };
      }
      sideBar[section].items.push(_objectSpread({
        section: section
      }, item));
    });
    return Object.values(sideBar);
  };

  /**
   * Construct filter object
   * 1. add facet values to facets
   * 2. add 'name' key to each facet value
   */
  var addFacetValues = function addFacetValues(facets) {
    var updateFacets = [];
    if (facets) {
      facets.forEach(function (facet) {
        var updateFacet = _objectSpread(_objectSpread({}, facet), {}, {
          facetValues: []
        });
        var field = updateFacet.field,
          ApiLowerBoundName = updateFacet.ApiLowerBoundName,
          ApiUpperBoundName = updateFacet.ApiUpperBoundName,
          apiForFiltering = updateFacet.apiForFiltering;
        if (data[apiForFiltering]) {
          if (Array.isArray(data[apiForFiltering])) {
            var updateField = data[apiForFiltering].map(function (item) {
              var addField = _objectSpread({}, item);
              addField.name = item[field];
              return addField;
            });
            updateFacet.facetValues = updateField;
          }
          /**
          * add object to facet values
          */
          if (facet.type === _Types.InputTypes.SLIDER) {
            var lowerBound = data[apiForFiltering][ApiLowerBoundName];
            var upperBound = data[apiForFiltering][ApiUpperBoundName];
            updateFacet.minLowerBound = lowerBound;
            updateFacet.maxUpperBound = upperBound;
            updateFacet.facetValues = [lowerBound, upperBound];
          }
        }
        updateFacets.push(updateFacet);
      });
    }
    return updateFacets;
  };

  /**
   * Generate facet sections state
   *
   */
  var displayFacets = facetsConfig.filter(function (facet) {
    return facet.show;
  }).slice(0, 16);
  var facetStates = addFacetValues(displayFacets);
  var updateState = updateFacetState(facetStates);
  var facetSections = arrangeBySections(updateState);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FacetFilterView.default, _extends({}, props, {
    sideBarSections: facetSections
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    filterState: state.statusReducer.filterState
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, null)(FacetFilterController);
exports.default = _default;